class StickyATCBanner extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.stickyATCBanner = this;
    this.stickyCTA = this.querySelector('[data-sticky-atc-cta]');
    this.atcButton = document.querySelector('[data-atc-button]');

    this.stickyPrice = this.querySelectorAll('[data-sticky-price]');
    this.stickyComparePrice = this.querySelectorAll('[data-sticky-compare-price]');

    this.siteFooter = document.querySelector('footer');
       
    this.setupEventListeners();
  }

  getProductCompareText() {
    const priceOnSale = document.querySelector('product-info .price--on-sale');
    if (!priceOnSale) return '';

    const productCompare = priceOnSale.querySelector('.price__sale .price-item.price-item--regular');
    return productCompare?.textContent.trim() || '';
  }

  updateStickyPrices() {
    const subscriptionWidget = document.querySelector('subscription-widget');

    if (subscriptionWidget) {
      const checkedInput = subscriptionWidget.querySelector('input[name="purchase_option"]:checked');
      if (!checkedInput) return;

      let priceText = '';
      let compareText = '';

      if (checkedInput.value === 'subscription') {
        const subscriptionOption = subscriptionWidget.querySelector('.subscription-widget__option--subscription');
        const priceEl = subscriptionOption?.querySelector('.subscription-widget__price:not(.subscription-widget__compare-price)');
        const compareEl = subscriptionOption?.querySelector('.subscription-widget__compare-price');

        if (priceEl) priceText = priceEl.textContent.trim();
        if (compareEl?.classList.contains('active') && compareEl.textContent.trim()) {
          compareText = compareEl.textContent.trim();
        }
      } else {
        const onetimeOption = subscriptionWidget.querySelector('.subscription-widget__option--onetime');
        const priceEl = onetimeOption?.querySelector('.subscription-widget__price:not(.subscription-widget__compare-price)');
        const compareEl = onetimeOption?.querySelector('.subscription-widget__compare-price');

        if (priceEl) priceText = priceEl.textContent.trim();
        if (compareEl?.classList.contains('active') && compareEl.textContent.trim()) {
          compareText = compareEl.textContent.trim();
        }
      }

      this.stickyPrice.forEach(el => { el.textContent = priceText; });
      this.stickyComparePrice.forEach(el => { el.textContent = compareText; });
    } else {
      let compareText = '';
      let priceText = '';

      compareText = this.getProductCompareText();

      const productPrice = document.querySelector('product-info .price--on-sale .price__sale .price-item.price-item--sale')
        || document.querySelector('product-info .price__regular .price-item.price-item--regular');
      if (productPrice) priceText = productPrice.textContent.trim();

      this.stickyComparePrice.forEach(el => { el.textContent = compareText; });
      this.stickyPrice.forEach(el => { el.textContent = priceText; });
    }
  }

  setupEventListeners() {
    let productId = this.dataset.stickyAtc;

    
    // Add selected variant to cart
    this.stickyCTA.addEventListener('click', () => {

      this.stickyCTA.classList.add('loading');

      document.querySelector(`[data-product-form="${productId }"] button[type="submit"]`).click();

      setTimeout(() => {
        this.stickyCTA.classList.remove('loading');
      }, 1000);
    });

    
    //Update the price on the sticky banner
    document.addEventListener('productInfoUpdated', () => {
      this.updateStickyPrices();
    });

    // Sync prices after subscription widget initializes
    setTimeout(() => this.updateStickyPrices(), 300);
 
    // Check if the ATC button is visible and hide/show the sticky ATC
    if (this.atcButton && this.stickyATCBanner) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          const scrolledPast = entry.boundingClientRect.bottom < 0;

          if (scrolledPast) {
            this.stickyATCBanner.classList.add('active');
          } else {
            this.stickyATCBanner.classList.remove('active');
          }
        },
        {
          threshold: 0,
        }
      );

      observer.observe(this.atcButton);
    }

    // Check if the stickyATC is hovering over the footer and hide it
    if (this.siteFooter && this.stickyATCBanner) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.stickyATCBanner.classList.add('hovering-footer');
          } else {
            this.stickyATCBanner.classList.remove('hovering-footer');
          }
        },
        {
          threshold: 0,
          rootMargin: `0px 0px -${this.stickyATCBanner.offsetHeight}px 0px`,
        }
      );

      observer.observe(this.siteFooter);
    }
  }
}

// Register the custom element
customElements.define("sticky-atc-banner", StickyATCBanner);